import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getTableVisual } from "../../data/visuals";

import styles from "./viz-table.css";

import type { TableVisualData } from "../../types.d";
import type { PropertyValues } from "lit";

@customElement("bp-viz-table")
export class VizTable extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: TableVisualData;

  render() {
    if (!this.data) return;

    if (this.data.minWidth) {
      this.style.setProperty("--min-width", this.data.minWidth);
    }

    return html` <div class="table">${unsafeHTML(this.data.body)}</div> `;
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getTableVisual(this.arcId)
      .then(({ data }) => {
        this.data = data;
      })
      .catch(() => undefined);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-table": VizTable;
  }
}
